import { NgModule } from '@angular/core';
import {
  AnonymousConsentsModule,
  AuthModule,
  CostCenterOccModule,
  ExternalRoutesModule,
  FeatureToggles,
  ProductModule,
  ProductOccModule,
  UserModule,
  UserOccModule,
  provideFeatureTogglesFactory,
} from '@spartacus/core';
import {
  AnonymousConsentManagementBannerModule,
  AnonymousConsentsDialogModule,
  BannerCarouselModule,
  BannerModule,
  BreadcrumbModule,
  CategoryNavigationModule,
  CmsParagraphModule,
  ConsentManagementModule,
  FooterNavigationModule,
  HamburgerMenuModule,
  HomePageEventModule,
  LinkModule,
  LoginRouteModule,
  LogoutModule,
  MyAccountV2Module,
  MyInterestsModule,
  NavigationEventModule,
  NavigationModule,
  NotificationPreferenceModule,
  PDFModule,
  PageTitleModule,
  PaymentMethodsModule,
  ProductCarouselModule,
  ProductFacetNavigationModule,
  ProductImagesModule,
  ProductIntroModule,
  ProductListModule,
  ProductPageEventModule,
  ProductReferencesModule,
  ProductSummaryModule,
  ProductTabsModule,
  ScrollToTopModule,
  SearchBoxModule,
  SiteContextSelectorModule,
  StockNotificationModule,
  TabParagraphContainerModule,
  VideoModule,
} from '@spartacus/storefront';
import { CustomProductDetailsPageModule } from '../configuration/CustomProductDetailsPageModule';
import { I18nConfigurationModule } from '../configuration/i18n.module';
import { CustomCartModule } from '../custom-cart/custom-cart.module';
import { CustomCheckoutModule } from '../custom-checkout/custom-checkout.module';
import { CustomFooterModule } from '../custom-footer/custom-footer.module';
import { CustomHeaderModule } from '../custom-header/custom-header.module';
import { CustomLoginModule } from '../custom-login/custom-login.module';
import { CustomMyaccountModule } from '../custom-myaccount/custom-myaccount.module';
import { CustomPdpModule } from '../custom-pdp/custom-pdp.module';
import { CustomProductListPageModule } from '../custom-plp/custom-product-list-page.module';
import { ServicesModule } from '../services/services.module';
import { SharedModule } from '../shared/shared.module';
import { CustomProductListingPageModule } from '../configuration/CustomProductListingPageModule';
import { AsmCustomer360FeatureModule } from './features/asm/asm-customer360-feature.module';
import { AsmFeatureModule } from './features/asm/asm-feature.module';
import { CartBaseFeatureModule } from './features/cart/cart-base-feature.module';
import { CartImportExportFeatureModule } from './features/cart/cart-import-export-feature.module';
import { CartQuickOrderFeatureModule } from './features/cart/cart-quick-order-feature.module';
import { CartSavedCartFeatureModule } from './features/cart/cart-saved-cart-feature.module';
import { WishListFeatureModule } from './features/cart/wish-list-feature.module';
import { CheckoutFeatureModule } from './features/checkout/checkout-feature.module';
import { OrderFeatureModule } from './features/order/order-feature.module';
import { OrganizationAccountSummaryFeatureModule } from './features/organization/organization-account-summary-feature.module';
import { OrganizationAdministrationFeatureModule } from './features/organization/organization-administration-feature.module';
import { OrganizationUnitOrderFeatureModule } from './features/organization/organization-unit-order-feature.module';
import { ProductImageZoomFeatureModule } from './features/product/product-image-zoom-feature.module';
import { QuoteFeatureModule } from './features/quote/quote-feature.module';
import { SmartEditFeatureModule } from './features/smartedit/smart-edit-feature.module';
import { StoreFinderFeatureModule } from './features/storefinder/store-finder-feature.module';
import { PersonalizationFeatureModule } from './features/tracking/personalization-feature.module';
import { UserFeatureModule } from './features/user/user-feature.module';
import { CustomOrderConfirmationModule } from '../custom-order-confirmation/custom-order-confirmation.module';
import { CustomCsvPageModule } from '../custom-csv-page/custom-csv-page.module';
import { CustomSlotsModule } from '../custom-slots/custom-slots.module';
import { CustomGuardsModule } from '../custom-guards/custom-guards.module';
import { CustomRoutingModule } from '../custom-routing/custom-routing.module';

@NgModule({
  declarations: [],
  imports: [
    AuthModule.forRoot(),
    LogoutModule,
    LoginRouteModule,
    HamburgerMenuModule,
    SiteContextSelectorModule,
    LinkModule,
    BannerModule,
    CmsParagraphModule,
    TabParagraphContainerModule,
    BannerCarouselModule,
    CategoryNavigationModule,
    NavigationModule,
    FooterNavigationModule,
    BreadcrumbModule,
    ScrollToTopModule,
    PageTitleModule,
    VideoModule,
    PDFModule,
    UserModule,
    UserOccModule,
    PaymentMethodsModule,
    NotificationPreferenceModule,
    MyInterestsModule,
    MyAccountV2Module,
    StockNotificationModule,
    ConsentManagementModule,
    // MyCouponsModule, // no coupons
    AnonymousConsentsModule.forRoot(),
    AnonymousConsentsDialogModule,
    AnonymousConsentManagementBannerModule,
    ProductModule.forRoot(),
    ProductOccModule,
    ProductListModule,
    SearchBoxModule,
    ProductFacetNavigationModule,
    ProductTabsModule,
    ProductCarouselModule,
    ProductReferencesModule,
    ProductImagesModule,
    ProductSummaryModule,
    ProductIntroModule,
    CostCenterOccModule,
    NavigationEventModule,
    HomePageEventModule,
    ProductPageEventModule,
    ExternalRoutesModule.forRoot(),
    UserFeatureModule,
    CartBaseFeatureModule,
    CartSavedCartFeatureModule,
    WishListFeatureModule,
    CartQuickOrderFeatureModule,
    CartImportExportFeatureModule,
    OrderFeatureModule,
    CheckoutFeatureModule,
    PersonalizationFeatureModule,
    OrganizationAdministrationFeatureModule,
    OrganizationAccountSummaryFeatureModule,
    OrganizationUnitOrderFeatureModule,
    StoreFinderFeatureModule,
    AsmFeatureModule,
    AsmCustomer360FeatureModule,
    SmartEditFeatureModule,
    // ProductVariantsFeatureModule, //No es necesario para B2B. Se puede deshabilitar // NOSONAR
    ProductImageZoomFeatureModule,
    QuoteFeatureModule,

    I18nConfigurationModule,

    // auth
    CustomProductDetailsPageModule,
    CustomProductListingPageModule,

    // Custom modules
    CustomPdpModule,
    CustomFooterModule,
    CustomLoginModule,
    CustomHeaderModule,
    CustomProductListPageModule,
    CustomPdpModule,
    ServicesModule,
    SharedModule,
    // CheckoutConfigurationModule,
    CustomCartModule,
    CustomCheckoutModule,
    CustomOrderConfirmationModule,
    CustomMyaccountModule,

    CustomCsvPageModule,

    CustomSlotsModule,

    CustomGuardsModule,

    CustomRoutingModule
  ],
  providers: [
    provideFeatureTogglesFactory(() => ({
      authorizationCodeFlowByDefault: true,
      incrementProcessesCountForMergeCart: true,
      dispatchLoginActionOnlyWhenTokenReceived: true,
      cdsLoginEventsToken: true,
    } as FeatureToggles)),
  ],
})
export class SpartacusFeaturesModule {}
